import { useState } from 'react'
import RateCardsTab from './RateCardsTab'
import CategoriesTab from './CategoriesTab'
import ChargeCodesTab from './ChargeCodesTab'
import LanesTab from './LanesTab'
import ImportExportTab from './ImportExportTab'

// Z80 Phase 1: Customer Pricing System admin page. Gary's spec described "Rate Cards Overview"
// and "Rate Card Detail" as two separate tabs -- combined into one "Rate Cards" tab here with
// internal list/detail view-switching instead (RateCardsTab.tsx), since Tab 2 only ever makes
// sense in the context of a card selected from Tab 1 -- same master-detail shape as every other
// edit flow in this app (a modal or a Back-link, not a permanently-visible second nav tab).

type TabType = 'Rate Cards' | 'Categories' | 'Charge Codes' | 'Lanes' | 'Import / Export'
const TABS: TabType[] = ['Rate Cards', 'Categories', 'Charge Codes', 'Lanes', 'Import / Export']

export default function PricingAdmin() {
  const [activeTab, setActiveTab] = useState<TabType>('Rate Cards')

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="w-full px-6 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mt-1">Pricing</h1>
          <p className="text-gray-500 dark:text-gray-400 text-sm mt-0.5">Customer rate cards, charge codes, and lanes.</p>
        </div>

        <div className="flex gap-4 border-b border-gray-200 dark:border-gray-700 mb-6 overflow-x-auto">
          {TABS.map(tab => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 font-medium border-b-2 transition-colors whitespace-nowrap ${
                activeTab === tab
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {activeTab === 'Rate Cards' && <RateCardsTab />}
        {activeTab === 'Categories' && <CategoriesTab />}
        {activeTab === 'Charge Codes' && <ChargeCodesTab />}
        {activeTab === 'Lanes' && <LanesTab />}
        {activeTab === 'Import / Export' && <ImportExportTab />}
      </div>
    </div>
  )
}
